import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import i18n from "../../../constants/i18n";
import getAppControlStore from "../../../stores/firebase-store/app-control";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";

const AppControlWarningPopUp = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const warningTitle = getAppControlStore().warningTitle.get();
  const warningMessage = getAppControlStore().warningMessage.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1500}
      height={1080}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        position: "fixed",
        top: 0,
        zIndex: 5
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="space-between"
        alignItems="center"
        withShadow={true}
        width={1000}
        height={300}
        color={colors.all.white}
        style={{
          position: "relative",
          borderRadius: 50,
          zIndex: 5
        }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={26}
          text={warningTitle}
          isSpan={false}
          color={colors.all.black}
          style={{}}
        />
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={18}
          text={warningMessage}
          isSpan={false}
          color={colors.all.black}
          style={{}}
        />
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          fDirection="row"
          justifyContent="center"
          alignItems="center"
          withShadow={false}
          width={500}
          height={100}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <FontAwesomeIcon
            className="clickable"
            onClick={() => {
              getAppControlStore().acknowledgeWarning();
            }}
            icon={faCheckCircle}
            color={colors.all.green}
            style={{}}
            size="3x"
          />
        </ET3Div>
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={16}
          text={i18n.get("OK")}
          isSpan={false}
          color={colors.all.black}
          style={{}}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default AppControlWarningPopUp;
